import {font_s_md, font_s_sm} from '@xpertdox_js/xdstyle';

export default {
  labTitle: {
    ...font_s_md,
    margin: '.8rem 0 .2rem',
  },
  labList: {
    paddingLeft: '2.2rem',
    margin: '.6rem 0 .12rem',
  },
  labItem: {
    ...font_s_sm,
  }
}
